import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/projects/$projectId/labour-evidence/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/projects/$projectId/labour-evidence/payroll', params, replace: true });
  },
});
